import { Minus, Plus, Users, Baby } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const validGuestCounts = (value) => value &&
  Number.isSafeInteger(value.adults_count) && value.adults_count >= 1 &&
  Number.isSafeInteger(value.children_count) && value.children_count >= 0;

export const GuestCountFields = ({ value, onChange, prefix, disabled = false }) => {
  const update = (key, count) => {
    if (!Number.isSafeInteger(count) || count < 0) return;
    const next = { ...value, [key]: count };
    if (next.adults_count === 0) next.children_count = 0;
    onChange(next);
  };
  return (
    <div data-testid={`${prefix}-guest-fields`} className="space-y-3 min-w-0">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {[
          { key: "adults_count", name: "adults", label: "Erwachsene", Icon: Users },
          { key: "children_count", name: "children", label: "Kinder (0–12 Jahre)", Icon: Baby },
        ].map(({ key, name, label, Icon }) => {
          const inactive = disabled || (name === "children" && value.adults_count === 0);
          return (
            <div key={key} data-testid={`${prefix}-${name}-field`}
              className={`min-w-0 rounded-md border p-3 transition-colors ${inactive ? "bg-gray-100 border-gray-200 text-gray-400" : "bg-white border-[#2d5016] text-[#2d5016]"}`}>
              <Label htmlFor={`${prefix}-${name}`} className="flex items-center gap-2 text-sm font-semibold mb-3">
                <Icon className="w-4 h-4 shrink-0" aria-hidden="true" />{label}
              </Label>
              <div className="flex items-center gap-2">
                <Button type="button" variant="outline" size="icon" className="h-10 w-10 shrink-0"
                  data-testid={`${prefix}-${name}-decrease`} aria-label={`${label} verringern`}
                  disabled={inactive || value[key] === 0} onClick={() => update(key, value[key] - 1)}>
                  <Minus className="w-4 h-4" />
                </Button>
                <Input id={`${prefix}-${name}`} data-testid={`${prefix}-${name}-input`}
                  type="number" inputMode="numeric" min="0" step="1" value={value[key]}
                  disabled={inactive} aria-label={label}
                  onChange={(event) => update(key, Number(event.target.value))}
                  className="h-10 min-w-0 text-center text-lg font-semibold px-1 disabled:bg-gray-200 disabled:opacity-100" />
                <Button type="button" variant="outline" size="icon" className="h-10 w-10 shrink-0"
                  data-testid={`${prefix}-${name}-increase`} aria-label={`${label} erhöhen`}
                  disabled={inactive} onClick={() => update(key, value[key] + 1)}>
                  <Plus className="w-4 h-4" />
                </Button>
              </div>
            </div>
          );
        })}
      </div>
      <p data-testid={`${prefix}-guest-total`} role="status" aria-live="polite" className="text-sm font-semibold text-[#2d5016]">
        Gäste gesamt: {value.adults_count + value.children_count}
      </p>
    </div>
  );
};